export default `
    <section class="top-toolbar" id="#= data.id #">
        <div class="col-xs-12 breadcrumb-toolbar">
            <div class="row mini-toolbar">
                # if (data.components) { #
                    #= data.components #
                # } else { #
                    <div class="col-sm-8 nopad">
                        # if (data.leftComponents) { #
                            <div class="toolbar-inset">
                                #= data.leftComponents #
                            </div>
                        # } #
                    </div>
                    <div class="col-sm-4 nopad">
                        # if (data.rightComponents) { #
                            <div class="toolbar-inset right">
                                #= data.rightComponents #
                            </div>
                        # } #
                    </div>
                # } #
            </div>
        </div>
    </section>
`;
